(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mbh-engraving-quantity"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('mbh-engraving-quantity'))customElements.define('mbh-engraving-quantity',class extends HTMLElement{
  connectedCallback(){
    if(this.ready)return;this.ready=true;
    this.addEventListener('click',e=>{const button=e.target.closest('[data-step]');if(!button)return;e.preventDefault();e.stopImmediatePropagation();this.updateQuantity(Number(this.querySelector('input').value)+Number(button.dataset.step))},true);
    this.addEventListener('change',e=>{e.stopImmediatePropagation();this.updateQuantity(Number(e.target.value))},true);
    this.addEventListener('keydown',e=>{if(e.key==='Enter'){e.preventDefault();e.stopImmediatePropagation();this.updateQuantity(Number(e.target.value))}},true);
  }
  async updateQuantity(quantity){
    if(this.busy||!Number.isInteger(quantity)||quantity<0)return;
    this.busy=true;this.setAttribute('aria-busy','true');
    const root=window.Shopify?.routes?.root||'/';
    try{
      const cartResponse=await fetch(root+'cart.js');if(!cartResponse.ok)throw new Error();
      const cart=await cartResponse.json();const key=this.dataset.key;
      const updates={[key]:quantity};
      cart.items.filter(item=>item.parent_relationship?.parent_key===key).forEach(item=>updates[item.key]=quantity);
      const response=await fetch(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates})});
      if(!response.ok)throw new Error();
      window.location.reload();
    }catch(e){this.busy=false;this.removeAttribute('aria-busy');let error=this.parentElement.querySelector('[data-engraving-error]');if(!error){error=document.createElement('p');error.dataset.engravingError='true';error.setAttribute('role','alert');this.parentElement.append(error)}error.textContent=this.dataset.error}
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mbh-paid-engraving"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('mbh-paid-engraving')){
  customElements.define('mbh-paid-engraving',class extends HTMLElement{
    connectedCallback(){
      this.form=document.getElementById(this.dataset.form);
      if(!this.form||this.ready)return;
      this.ready=true;
      this.paid=false;
      this.variants=JSON.parse(this.querySelector('[data-variants]').textContent);
      this.text=this.querySelector('.mbh-engraving-text');
      this.fonts=Array.from(this.querySelectorAll('[data-font]'));
      this.money=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:this.dataset.currency||'USD'});
      this.change=()=>this.update();
      this.addEventListener('input',this.change);
      this.addEventListener('change',this.change);
      this.quantityChange=e=>{if(e.target.name==='quantity' && e.target.form===this.form)this.update()};
      document.addEventListener('input',this.quantityChange);
      document.addEventListener('change',this.quantityChange);
      document.addEventListener('variant:change',this.change);
      this.submit=e=>{if(e.target===this.form)this.addToCart(e)};
      document.addEventListener('submit',this.submit,true);
      this.update();
    }
    disconnectedCallback(){document.removeEventListener('submit',this.submit,true);document.removeEventListener('input',this.quantityChange);document.removeEventListener('change',this.quantityChange);document.removeEventListener('variant:change',this.change)}
    update(){
      this.paid=this.querySelector('input[value="paid"]').checked;
      this.querySelector('.mbh-engraving-fields').hidden=!this.paid;
      this.text.disabled=!this.paid;
      this.text.required=this.paid;
      this.fonts.forEach(input=>input.disabled=!this.paid);
      this.querySelector('[data-count]').textContent=Array.from(this.text.value).length+' / 30';
      const currentData=new FormData(this.form);
      const currentVariant=this.variants.find(variant=>String(variant.id)===String(currentData.get('id')));
      const basePrice=currentVariant?currentVariant.price:Number(this.dataset.base);
      const qty=Math.max(1,Number(currentData.get('quantity'))||1);
      this.querySelector('[data-total]').textContent=this.money.format((basePrice+(this.paid?Number(this.dataset.fee):0))*qty/100);
    }
    async addToCart(e){
      e.preventDefault();e.stopImmediatePropagation();
      if(this.busy)return;
      if(this.paid&&!this.text.value.trim()){this.text.setCustomValidity('Please enter your engraving text.');this.text.reportValidity();this.text.addEventListener('input',()=>this.text.setCustomValidity(''),{once:true});return}
      const data=new FormData(this.form);
      const quantity=Math.max(1,Number(data.get('quantity'))||1);
      const id=Number(data.get('id'));
      const items=[{id,quantity}];
      if(this.paid){
        items[0].properties={_mbh_engraving_group:crypto.randomUUID()};
        items.push({id:Number(this.dataset.variant),quantity,parent_id:id,properties:{'For bag':this.dataset.productTitle,'Personalization':this.text.value.trim(),'Font Style':this.querySelector('[data-font]:checked').value}});
      }
      const error=this.querySelector('[data-error-message]');error.hidden=true;
      this.busy=true;this.form.setAttribute('aria-busy','true');
      const buttons=this.form.querySelectorAll('[type=submit]');buttons.forEach(b=>b.disabled=true);
      try{
        const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});
        const result=await response.json();
        if(!response.ok)throw new Error(result.description||this.dataset.error);
        window.location.assign(this.dataset.cart);
      }catch(err){error.textContent=err.message||this.dataset.error;error.hidden=false;this.busy=false;this.form.removeAttribute('aria-busy');buttons.forEach(b=>b.disabled=false)}
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
